import React, { useEffect, useState } from "react";
import Bloc1 from "./Bloc1";
import Bloc2 from "./Bloc2";
import Bloc3 from "./Bloc3";
import Bloc4 from "./Bloc4";
import Bloc5 from "./Bloc5";
import Bloc6 from "./Bloc6";
import Bloc7 from "./Bloc7";
import { Link, useNavigate } from "react-router-dom";
import Bloc8 from "./Bloc8";
import Bloc9 from "./Bloc9";
import Bloc10 from "./Bloc10";
import Bloc11 from "./Bloc11";
import { INoticeDetails } from "../../../models/interfaces/INotice";
import { ModificationBloque } from "../../../config/helpers";
import { toast } from "react-toastify";
import SpinnerEditeurPro from "../components/SpinnerEditeurPro";
import BlocLivreEnMain from "./BlocLivreEnMain";

interface IProps {
  btnModifierAutoVisible:boolean;
  btnModifierMessageVisible:boolean;
  //navigatorPath: string;
  NoticeResult: INoticeDetails|undefined;
  isFetchingNoticeResult:boolean;
}
//navigatorPath
const NoticeDetails: React.FC<IProps> = ({ NoticeResult,isFetchingNoticeResult,btnModifierAutoVisible,btnModifierMessageVisible}) => { 
 

  const [pathSource, setPathSource] = useState<string>("");
  const navigate = useNavigate();


  useEffect(() => {
    const pathParts = location.pathname.split("/").filter(Boolean); // Supprime les éventuels espaces vides

    if (pathParts.length >= 1 ) {
      setPathSource(`/${pathParts[0]}`);

      }
  }, [location.pathname, navigate]);


  

  const ModificationMessageBloqueMessage = ModificationBloque(
    NoticeResult?.Source ?? "",
    NoticeResult?.Support?.supportId ?? "",
    "Modifcations par message impossible pour cette notice.");

    const ModificationAutoBloqueMessage = ModificationBloque(
      NoticeResult?.Source ?? "",
      NoticeResult?.Support?.supportId ?? "",
      "Modifcations automatisés impossible pour cette notice.");


   return (
    <>
    
    {
      (!NoticeResult ||isFetchingNoticeResult) ?  
      <SpinnerEditeurPro />
      :
    <>
     <div className="card pae-detail-pub-card">
      <div className="card-body pae-form-container row">
      
        <div className="col-xl-9  col-md-6  col-12 mt-2">
          {/* Début Bloc 1      */}
          <div className="row">
            <div className="col-12">
              <Bloc1 NoticeResult={NoticeResult}></Bloc1>
            </div>
          </div>
          {/* Fin Bloc 1      */}
          <div className="row mt-2">
          <div className="col-xl-4 col-md-6 col-12 mt-2">
            <div className="pae-detail-linked-file">
            {/* Début Bloc 2     */}
            
              <Bloc2 NoticeResult={NoticeResult}></Bloc2>
                {(btnModifierAutoVisible || btnModifierMessageVisible) && 
                  <div className="card p-2 mt-1 mb-2" style={{ textAlign: 'left' }}>
                   {btnModifierAutoVisible && (
                      <Link
                        to={ModificationAutoBloqueMessage === undefined ? `${pathSource}/noticedetailsmodifauto/${NoticeResult?.Ean}/${NoticeResult?.Id}` : ""}
                        className={`App-link ${ModificationAutoBloqueMessage === undefined ? 'btn btn-secondary' : 'btn btn-red'} d-flex mt-1 mb-1`}
                        onClick={ModificationAutoBloqueMessage !== undefined ? () => toast.error(ModificationAutoBloqueMessage) : undefined}
                      >
                        <i className="bi-pencil-square pe-2 App-icon-size" /><br />
                        <div className="desktop-only-section">Modifications physiques et commerciales</div>
                      </Link>
                    )}
                    {btnModifierMessageVisible && (
                      <Link
                        to={ModificationMessageBloqueMessage === undefined ? `${pathSource}/noticedetailsmessage/${NoticeResult?.Ean}/${NoticeResult?.Id}` : ""}
                        className={`App-link ${ModificationMessageBloqueMessage === undefined ? 'btn btn-secondary' : 'btn btn-red'} d-flex mt-1 mb-1`}
                        onClick={ModificationMessageBloqueMessage !== undefined ? () => toast.error(ModificationMessageBloqueMessage) : undefined}
                      >
                        <i className="bi-chat-left-text pe-2 App-icon-size" />
                        <div className="desktop-only-section">Autres modifications</div>
                      </Link>
                    )}
                  </div>
                }
              
                <Bloc3 NoticeResult={NoticeResult?.Bloc3}></Bloc3>
                
                <BlocLivreEnMain NoticeDetails={NoticeResult}></BlocLivreEnMain>
            </div>
          </div>
          <div className="col-xl-8 col-md-6 col-12 mt-2">
            <Bloc4 NoticeResult={NoticeResult}></Bloc4>
            <Bloc5 NoticeResult={NoticeResult}></Bloc5>
            <Bloc6 NoticeResult={NoticeResult}></Bloc6>
            <Bloc7 NoticeResult={NoticeResult}></Bloc7>     
          </div>
        </div>
        </div>
        <div className="col-xl-3  col-md-6  col-12 mt-2">       
         
        <Bloc8 NoticeResult={NoticeResult}></Bloc8>
        <Bloc9 NoticeResult={NoticeResult}></Bloc9>   
        <Bloc10 NoticeResult={NoticeResult}></Bloc10>
        <Bloc11 NoticeResult={NoticeResult}></Bloc11>
        </div>
      </div>
    </div>
   
    </>
    }
    </>
  );
};

export default NoticeDetails;
